import { gql } from '@apollo/client';

export const MESSAGE_FIELDS_FRAGMENT = gql`
  fragment MessageFields on Message {
    objectId: id
    createdAt
    originalCreatedAt
    messageType
    fromChannel
    simplrExpertPtr {
      objectId: id
      isAdmin
      firstName
      lastName
      email
      isSystemExpert
    }
    source
    messageSignatureText
    direction
    messageBody
    toChannel
    subject
    messagePlain
    messageHtml
    hiddenContent
    mediaUrl
    simplrAccountPtr {
      objectId: id
    }
    conversationPtr {
      objectId: id
    }
    smbName
    hasRead
    status
    customerPtr {
      objectId: id
      customerFirstName
      createdAt
    }
    couponCodePtr {
      code
      createdAt
    }
    decisionTreeCouponCode
    noteType
    platformDomain
    platformTicketId
    originalMessage
    translatedMessage
    detectedLanguage
  }
`;
